import { onDocumentLoaded } from '@theme/utilities';

const TRANSITION_DURATION = 800;
const EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

/**
 * Smooth logo crossfade on homepage when scrolling.
 * Observes header sticky state and animates opacity between original and inverse logo.
 */
function initLogoTransition() {
  const header = document.querySelector('#header-component');
  if (!header?.hasAttribute('transparent') || header.hasAttribute('data-not-homepage')) {
    return;
  }

  const logo = header.querySelector('.header-logo');
  const originalContainer = logo?.querySelector('.header-logo__image-container--original');
  const inverseContainer = logo?.querySelector('.header-logo__image-container--inverse');

  if (!logo || !originalContainer || !inverseContainer) {
    return;
  }

  let observer = null;

  const setLogoOpacity = (isScrolled) => {
    originalContainer.style.opacity = isScrolled ? '1' : '0';
    inverseContainer.style.opacity = isScrolled ? '0' : '1';
  };

  const updateFromState = () => {
    const state = header.dataset.stickyState;
    const isScrolled = state === 'active' || state === 'idle' ||
                       (!state && window.scrollY > 0);
    setLogoOpacity(isScrolled);
  };

  const activate = () => {
    logo.classList.add('header-logo--crossfade');
    updateFromState();

    if (!observer) {
      observer = new MutationObserver(updateFromState);
      observer.observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
    }
  };

  const deactivate = () => {
    logo.classList.remove('header-logo--crossfade');
    originalContainer.style.opacity = '';
    inverseContainer.style.opacity = '';

    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  activate();
}

onDocumentLoaded(initLogoTransition);
